(function() {
  'use strict';

  const NC_KEY = ncVehicle.KEY;
  const API_BASE = ncVehicle.API;
  const T = window.NC_I18N.garage;

  // ── DOM refs ──────────────────────────────────────────────────────────────
  const garage       = document.getElementById('nc-garage');
  const garageBtn    = document.getElementById('nc-garage-btn');
  const dropdown     = document.getElementById('nc-garage-dropdown');
  const carNameEl    = document.getElementById('nc-garage-car-name');
  const ddCarEl      = document.getElementById('nc-garage-dd-car');
  const ddCarNameEl  = document.getElementById('nc-garage-dd-car-name');
  const ddCountEl    = document.getElementById('nc-garage-dd-count');
  const ddActionsEl  = document.getElementById('nc-garage-dd-actions');
  const ddEmptyEl    = document.getElementById('nc-garage-dd-empty');
  const ddShopLink   = document.getElementById('nc-garage-dd-shop-link');
  const ddChangeBtn  = document.getElementById('nc-garage-dd-change-btn');
  const ddResetBtn   = document.getElementById('nc-garage-dd-reset-btn');
  const ddAddBtn     = document.getElementById('nc-garage-dd-add-btn');

  // Modal
  const overlay      = document.getElementById('nc-garage-modal-overlay');
  const modalClose   = document.getElementById('nc-garage-modal-close');
  const modalCancel  = document.getElementById('nc-garage-modal-cancel');
  const modalSubmit  = document.getElementById('nc-garage-modal-submit');
  const modalSpinner = document.getElementById('nc-garage-modal-spinner');
  const modalFields  = document.getElementById('nc-garage-modal-fields');
  const gmMake       = document.getElementById('nc-gm-make');
  const gmModel      = document.getElementById('nc-gm-model');
  const gmType       = document.getElementById('nc-gm-type');

  // ── Storage helpers ───────────────────────────────────────────────────────
  function loadCar() {
    return ncVehicle.load();
  }
  function saveCar(data) {
    ncVehicle.save(data);
  }


  function buildVehicleCollectionUrl(car) { return ncVehicle.carUrl(car); }


  // Migrér en ældre gemt bil, hvor typeHandle tidligere pegede på model-URL'en.
  // vehicle_type_id bevares uændret som intern sporbarhed.
  function migrateLegacySavedCar() {
    const car = loadCar();
    const typeId = String(car && car.typeId || '').trim();
    if (!car || !/^\d+$/.test(typeId) || (car.typeHandle && car.typeHandle !== car.modelHandle)) return;
    fetch(API_BASE + '/collection-handle?typeId=' + encodeURIComponent(typeId), { cache: 'no-store' })
      .then(function(response) { return response.ok ? response.json() : null; })
      .then(function(payload) {
        const handle = payload && (payload.handle || payload.collectionHandle);
        if (!handle) return;
        car.typeHandle = String(handle);
        saveCar(car);
        document.dispatchEvent(new CustomEvent('nc:car-saved', { detail: car }));
      })
      .catch(function() { /* Eksisterende model-URL bevares ved netværksfejl. */ });
  }

  // ── Render header widget ──────────────────────────────────────────────────
  function renderGarage() {
    garage.setAttribute('data-nc-ready', '');
    const car = loadCar();
    if (car && car.typeName) {
      garage.classList.remove('nc-garage--empty');
      carNameEl.textContent = ncVehicle.typeLabel(car.typeName);
      garageBtn.setAttribute('aria-label', T.title + ': ' + carNameEl.textContent);
      ddCarNameEl.textContent = carNameEl.textContent;
      ddCountEl.textContent = car.productCount > 0 ? T.partsCount.replace('%d', car.productCount) : T.seeParts;
      ddShopLink.href = buildVehicleCollectionUrl(car);
      ddCarEl.style.display = '';
      ddActionsEl.style.display = '';
      ddEmptyEl.style.display = 'none';
    } else {
      garage.classList.add('nc-garage--empty');
      carNameEl.textContent = T.addVehicle;
      garageBtn.setAttribute('aria-label', T.title + ': ' + T.addVehicle);
      ddCarEl.style.display = 'none';
      ddActionsEl.style.display = 'none';
      ddEmptyEl.style.display = '';
    }
  }

  // ── Dropdown toggle ───────────────────────────────────────────────────────
  function openDropdown() {
    dropdown.setAttribute('data-open', '');
    garageBtn.setAttribute('aria-expanded', 'true');
  }
  function closeDropdown() {
    dropdown.removeAttribute('data-open');
    garageBtn.setAttribute('aria-expanded', 'false');
  }
  function toggleDropdown() {
    if (dropdown.hasAttribute('data-open')) { closeDropdown(); } else { openDropdown(); }
  }

  garageBtn.addEventListener('click', function(e) {
    e.stopPropagation();
    toggleDropdown();
  });

  // Close on outside click
  document.addEventListener('click', function(e) {
    if (!garage.contains(e.target)) { closeDropdown(); }
  });

  // Close on Escape
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeDropdown();
      closeModal();
    }
  });

  // ── Modal ─────────────────────────────────────────────────────────────────
  // WCAG 2.4.3: fokus flyttes ind i dialogen, holdes der (Tab-fælde) og sendes tilbage ved luk.
  var modalOpener = null;
  function modalFocusables() {
    return Array.prototype.filter.call(overlay.querySelectorAll('select, button, a[href], input, [tabindex]:not([tabindex="-1"])'), function(el) {
      return !el.disabled && el.offsetParent !== null;
    });
  }
  overlay.addEventListener('keydown', function(e) {
    if (e.key !== 'Tab' || !overlay.hasAttribute('data-open')) return;
    var f = modalFocusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  function openModal() {
    closeDropdown();
    modalOpener = document.activeElement;
    overlay.setAttribute('data-open', '');
    document.body.style.overflow = 'hidden';
    setTimeout(function() { var f = modalFocusables(); if (f.length) f[0].focus(); }, 50);
    loadMakesInModal();
    // Pre-select existing car
    const car = loadCar();
    if (car) {
      // Will be handled after makes load
      overlay._preselect = car;
    }
  }
  function closeModal() {
    var wasOpen = overlay.hasAttribute('data-open');
    overlay.removeAttribute('data-open');
    if (wasOpen && modalOpener && document.contains(modalOpener)) modalOpener.focus();
    modalOpener = null;
    document.body.style.overflow = '';
    overlay._preselect = null;
    resetModalSelects();
  }

  function resetModalSelects() {
    gmMake.innerHTML = '<option value="">' + T.makePlaceholder + '</option>';
    gmModel.innerHTML = '<option value="">' + T.modelPlaceholder + '</option>';
    gmType.innerHTML = '<option value="">' + T.typePlaceholder + '</option>';
    gmMake.disabled = false;
    gmModel.disabled = true;
    gmType.disabled = true;
    modalSubmit.disabled = true;
  }

  function showModalSpinner(show) {
    modalSpinner.classList.toggle('active', show);
    modalFields.style.display = show ? 'none' : '';
  }

  async function loadMakesInModal() {
    showModalSpinner(true);
    try {
      const res = await fetch(API_BASE + '/makes');
      const data = await res.json();
      const makes = ncVehicle.byName(data.makes || data);
      gmMake.innerHTML = '<option value="">' + T.makePlaceholder + '</option>';
      makes.forEach(function(m) {
        const opt = document.createElement('option');
        opt.value = m.id || m.makeId || m.slug || m.name;
        opt.textContent = m.name;
        opt.dataset.name = m.name;
        gmMake.appendChild(opt);
      });
      gmMake.disabled = false;
      showModalSpinner(false);

      // Pre-select if we have a saved car
      const pre = overlay._preselect;
      if (pre && pre.makeId) {
        gmMake.value = pre.makeId;
        await loadModelsInModal(pre.makeId, pre.modelId);
      }
    } catch(e) {
      showModalSpinner(false);
      gmMake.disabled = false;
    }
  }

  async function loadModelsInModal(makeId, preselectModelId) {
    gmModel.innerHTML = '<option value="">' + T.loadingModels + '</option>';
    gmModel.disabled = true;
    gmType.innerHTML = '<option value="">' + T.typePlaceholder + '</option>';
    gmType.disabled = true;
    modalSubmit.disabled = true;
    try {
      const res = await fetch(API_BASE + '/models?makeId=' + encodeURIComponent(makeId));
      const data = await res.json();
      const models = ncVehicle.withParts(data.models || data);
      if (gmMake.value !== String(makeId)) return; // a newer make was picked while this loaded
      gmModel.innerHTML = '<option value="">' + T.modelPlaceholder + '</option>';
      models.forEach(function(m) {
        const opt = document.createElement('option');
        opt.value = m.id || m.modelId || m.slug || m.name;
        opt.textContent = m.name;
        opt.dataset.name = m.name;
        opt.dataset.handle = m.collectionHandle || '';
        opt.dataset.productCount = String(m.product_count || 0);
        opt.dataset.hasVariants = m.hasVariants ? '1' : '0';
        gmModel.appendChild(opt);
      });
      gmModel.disabled = false;
      modalSubmit.disabled = false; // mærke alene kan gemmes (som forside og vehicle-bar)
      if (preselectModelId) {
        gmModel.value = preselectModelId;
        if (isModelOnly()) return;
        await loadTypesInModal(makeId, preselectModelId, overlay._preselect && overlay._preselect.typeId);
      }
    } catch(e) {
      gmModel.disabled = false;
    }
  }

  async function loadTypesInModal(makeId, modelId, preselectTypeId) {
    gmType.innerHTML = '<option value="">' + T.loadingTypes + '</option>';
    gmType.disabled = true;
    modalSubmit.disabled = true;
    try {
      const res = await fetch(API_BASE + '/types?makeId=' + encodeURIComponent(makeId) + '&modelId=' + encodeURIComponent(modelId));
      const data = await res.json();
      const types = ncVehicle.withParts(data.types || data);
      if (gmModel.value !== String(modelId)) return; // a newer model was picked while this loaded
      gmType.innerHTML = '<option value="">' + T.typePlaceholder + '</option>';
      types.forEach(function(t) {
        const opt = document.createElement('option');
        opt.value = t.id || t.typeId;
        opt.textContent = ncVehicle.typeLabel(t.name);
        opt.dataset.name = opt.textContent;
        opt.dataset.handle = t.collectionHandle || t.handle || '';
        opt.dataset.productCount = String(t.product_count || 0);
        gmType.appendChild(opt);
      });
      gmType.disabled = false;
      modalSubmit.disabled = false; // model alene kan gemmes; varianten indsnævrer
      if (preselectTypeId) gmType.value = preselectTypeId;
    } catch(e) {
      gmType.disabled = false;
    }
  }

  // Modal select events
  gmMake.addEventListener('change', function() {
    if (this.value) {
      loadModelsInModal(this.value, null);
    } else {
      gmModel.innerHTML = '<option value="">' + T.modelPlaceholder + '</option>';
      gmModel.disabled = true;
      gmType.innerHTML = '<option value="">' + T.typePlaceholder + '</option>';
      gmType.disabled = true;
      modalSubmit.disabled = true;
    }
  });

  // Models without types are saved as model-only picks, like nc-vehicle-bar.js
  function isModelOnly() {
    const opt = gmModel.options[gmModel.selectedIndex];
    return !!(opt && opt.value && opt.dataset.hasVariants !== '1' && opt.dataset.handle);
  }

  gmModel.addEventListener('change', function() {
    gmType.innerHTML = '<option value="">' + T.typePlaceholder + '</option>';
    gmType.disabled = true;
    modalSubmit.disabled = !gmMake.value;
    if (this.value && gmMake.value && !isModelOnly()) loadTypesInModal(gmMake.value, this.value, null);
  });

  // Submit: save car (no redirect)
  modalSubmit.addEventListener('click', function() {
    const typeOpt = gmType.options[gmType.selectedIndex];
    const modelOpt = gmModel.options[gmModel.selectedIndex];
    const makeOpt = gmMake.options[gmMake.selectedIndex];
    if (!gmMake.value) return;
    // Mærke, model eller variant — samme bil-objekt som forside og vehicle-bar (ncVehicle.car).
    const hasModel = !!(gmModel.value && modelOpt && modelOpt.dataset.handle);
    const hasType = hasModel && !!(typeOpt && typeOpt.value && typeOpt.dataset.handle);
    const carData = ncVehicle.car({
      makeId: gmMake.value, makeName: makeOpt ? makeOpt.dataset.name || makeOpt.textContent : '',
      modelId: hasModel ? gmModel.value : null, modelName: hasModel ? modelOpt.dataset.name || modelOpt.textContent : '',
      modelHandle: hasModel ? modelOpt.dataset.handle : '',
      typeId: hasType ? typeOpt.value : null, typeHandle: hasType ? typeOpt.dataset.handle : '', typeName: hasType ? typeOpt.textContent : '',
      productCount: parseInt(((hasType ? typeOpt : hasModel ? modelOpt : null) || { dataset: {} }).dataset.productCount || '0', 10) || 0
    });
    saveCar(carData);

    // Dispatch event so other components (e.g. car-selector on homepage) can react
    document.dispatchEvent(new CustomEvent('nc:car-saved', { detail: carData }));

    closeModal();
    renderGarage();

    // Gem navigerer ikke. Collection/søg læser bilen ved indlæsning → genindlæs (som nc-vehicle-bar.js);
    // ellers vises dropdownen med bilen og det separate link "Se dele til din bil".
    // På en bilside (fx Lamborghini Aventador) er siden selv bilen: gå til den nye bils side.
    if (ncVehicle.onCarPage()) {
      try { sessionStorage.setItem('nc_garage_pulse', '1'); } catch(e) {}
      location.href = ncVehicle.carUrl(carData);
    } else if (/^\/(collections|search)(\/|$)/.test(ncVehicle.localPath(location.pathname))) {
      try { sessionStorage.setItem('nc_garage_pulse', '1'); } catch(e) {}
      location.reload();
    } else {
      setTimeout(openDropdown); // efter klikket, som ellers lukker den igen (outside-click)
    }
  });

  // Close modal
  [modalClose, modalCancel].forEach(function(btn) {
    btn.addEventListener('click', closeModal);
  });
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeModal();
  });

  // Åbn modal fra andre komponenter (fx nc-vehicle-bar)
  document.addEventListener('nc:open-garage-modal', function() { openModal(); });

  // ── "Bilen lægges i garagen": flyvende stjerne + puls på stjernen ──────────
  function playGarageAdd(fromRect) {
    if (garage.classList.contains('nc-garage--empty')) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var to = garageBtn.getBoundingClientRect();
    function pulse() {
      garage.classList.remove('nc-garage--pulse');
      void garage.offsetWidth;
      garage.classList.add('nc-garage--pulse');
      setTimeout(function() { garage.classList.remove('nc-garage--pulse'); }, 1400);
    }
    if (reduce || !to.width || !garage.animate) { pulse(); return; }
    var from = fromRect || { left: window.innerWidth / 2, top: window.innerHeight / 3, width: 0, height: 0 };
    var fly = document.createElement('div');
    fly.className = 'nc-garage-fly';
    fly.innerHTML = '<svg class="nc-garage-fly__star" aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3 6.1 20.6l1.3-6.6L2.5 9.4l6.6-.8z"/></svg>'
    document.body.appendChild(fly);
    var sx = from.left + from.width / 2 - 14, sy = from.top + from.height / 2 - 14;
    var ex = to.left + 14, ey = to.top + 6;
    fly.animate([
      { transform: 'translate(' + sx + 'px,' + sy + 'px) scale(.4)', opacity: 0 },
      { transform: 'translate(' + sx + 'px,' + (sy - 30) + 'px) scale(1.5)', opacity: 1, offset: .25 },
      { transform: 'translate(' + ex + 'px,' + ey + 'px) scale(.8)', opacity: 1 }
    ], { duration: 750, easing: 'cubic-bezier(.4,0,.2,1)' }).onfinish = done;
    var finished = false;
    function done() { if (finished) return; finished = true; fly.remove(); pulse(); }
    setTimeout(done, 1000); // fallback hvis fanen er i baggrunden og animationen står stille
  }
  document.addEventListener('nc:car-added', function(e) { renderGarage(); playGarageAdd(e.detail && e.detail.fromRect); });
  try {
    if (sessionStorage.getItem('nc_garage_pulse')) {
      sessionStorage.removeItem('nc_garage_pulse');
      window.addEventListener('load', function() { setTimeout(function() { playGarageAdd(null); }, 300); });
    }
  } catch(e) {}

  // Open modal from dropdown buttons
  ddChangeBtn.addEventListener('click', function() { openModal(); });
  // Reset / clear saved car
  ddResetBtn.addEventListener('click', function() {
    ncVehicle.clear();
    closeDropdown();
    renderGarage();
    // Also fire event so homepage selector can reset itself
    document.dispatchEvent(new CustomEvent('nc:car-cleared'));
    // Collection/søg læser bilen ved indlæsning (som ved Gem): genindlæs, så listen ikke bliver
    // stående filtreret på den fjernede bil.
    if (/^\/(collections|search)(\/|$)/.test(ncVehicle.localPath(location.pathname))) location.reload();
  });
  ddAddBtn.addEventListener('click', function() {
    // If on homepage, scroll to car selector instead
    const homepageSelector = document.getElementById('nc-make-select');
    if (homepageSelector) {
      closeDropdown();
      homepageSelector.scrollIntoView({ behavior: 'smooth', block: 'center' });
      homepageSelector.focus();
    } else {
      openModal();
    }
  });

  // Listen for car saved from the main homepage selector
  document.addEventListener('nc:car-saved', function(e) {
    renderGarage();
  });

  // Also listen for storage changes (other tabs)
  window.addEventListener('storage', function(e) {
    if (e.key === NC_KEY) renderGarage();
  });





  // ── Rene Min Garage-URL'er i megamenuen ───────────────────────────────────
  // Bilens compatibility-filter læses internt af Typesense fra Min Garage.
  // Derfor må vehicle_type_id aldrig være synlig i navigations-URL'en.
  var NC_GARAGE_FILTER_EXCLUDED_COLLECTIONS = { tilbud: true, udsalg: true, sale: true, brands: true, maerker: true };
  function buildGarageFilteredMenuHref(rawHref) {
    if (!rawHref) return null;
    var url;
    try { url = new URL(rawHref, window.location.origin); } catch (e) { return null; }
    if (url.origin !== window.location.origin) return null;
    var match = ncVehicle.localPath(url.pathname).match(/^\/collections\/([^/?#]+)\/?$/);
    if (!match || NC_GARAGE_FILTER_EXCLUDED_COLLECTIONS[String(match[1]).toLowerCase()]) return null;
    url.searchParams.delete('vehicle_type_id');
    return url.pathname + url.search + url.hash;
  }
  function syncGarageFilteredMenuLinks() {
    var links = document.querySelectorAll('.nav-main a[href], .navigation-mobile-menu a[href], .navigation-mobile a[href]');
    links.forEach(function(link) {
      var originalHref = link.getAttribute('data-nc-garage-original-href') || link.getAttribute('href') || '';
      if (!originalHref) return;
      if (!link.getAttribute('data-nc-garage-original-href')) link.setAttribute('data-nc-garage-original-href', originalHref);
      var filteredHref = buildGarageFilteredMenuHref(originalHref);
      link.setAttribute('href', filteredHref || originalHref);
    });
  }
  // Opdatér lige før navigation som en sikkerhed mod valg foretaget på forsiden.
  document.addEventListener('click', function(event) {
    var target = event.target;
    var link = target && target.closest ? target.closest('.nav-main a[href], .navigation-mobile-menu a[href], .navigation-mobile a[href]') : null;
    if (!link) return;
    var originalHref = link.getAttribute('data-nc-garage-original-href') || link.getAttribute('href') || '';
    var filteredHref = buildGarageFilteredMenuHref(originalHref);
    if (filteredHref) link.setAttribute('href', filteredHref);
  }, true);
  document.addEventListener('nc:car-saved', syncGarageFilteredMenuLinks);
  document.addEventListener('nc:car-cleared', syncGarageFilteredMenuLinks);
  window.addEventListener('storage', function(event) {
    if (event.key === NC_KEY) syncGarageFilteredMenuLinks();
  });
  // Snippetten renderes før selve nav-main markup'en i headeren. Vent derfor på
  // DOMContentLoaded, så en gemt bil også filtrerer links efter en almindelig
  // sidenavigation — ikke kun efter et manuelt bilskift på samme side. Shopify
  // kan hydrere localStorage-baserede headerdata sent; én kort retry gør den
  // første sideindlæsning deterministisk uden vedvarende polling.
  function initialiseGarageFilteredMenuLinks() {
    syncGarageFilteredMenuLinks();
    window.setTimeout(syncGarageFilteredMenuLinks, 150);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseGarageFilteredMenuLinks, { once: true });
  } else {
    initialiseGarageFilteredMenuLinks();
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  migrateLegacySavedCar();
  renderGarage();

})();
